
    import "/home/git/waysglob/website/src/components/learn-more/index.module.scss.FARM_CSS_MODULES?1cdbcb7c";
    
    export default {"learn-more": `learn-more-360bd150`}
    